import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

const DestinationBanner = () => {
    return (
        <div>
            <video
                className="banner-wrapper"
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                disablePictureInPicture
                controlsList="nodownload noplaybackrate nofullscreen"
                style={{height: '370px'}}
            >
                <source 
                    src={require('../../../assets/videos/headervideo/header-video.mp4')} 
                    type="video/mp4"
                />
            </video>

            <div className="gradient-overlay">
                <Container className="py-5" >
                    <Row className="d-flex align-items-center justify-content-center">
                        <Col xxl={6} xl={6} lg={8} md={10} sm={12} xs={12} className="text-center">
                            <p className="fs-28 fw-400 sub-header text-black mb-1">
                                Park Map and Tour
                            </p>
                            <p className='fw-400 header'>
                                Top Destinations
                            </p>
                            <p className='sub-heading-text fw-400 text-black'>
                                Sign up and be the first to know the latest news, offers, promotions and special events of our Water World.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default DestinationBanner
